import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ClaimType.List.IRequest;
type Response = Api.Core.ClaimType.List.IResponse;
type Headers = Api.Core.ClaimType.List.IHeaders;
const url = '/api/Claims/ClaimType';
export default async function claimTypeListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
